import type { ViewProps } from 'react-native';
import type { IconName } from '@sg/garnish';

import { TierName } from '@order/graphql';

import type { AccountSweetpassBillingHistorySection } from '../../useSweetpassAccountContentfulData';
import type { GetSectionProps, SweetpassSectionProps } from '../types';

export const getBillingHistorySection = (
  props: GetBillingHistorySectionProps,
): SweetpassBillingHistorySectionProps | undefined => {
  const {
    name,
    billingHistoryDataTitle,
    hasPaidTierHistory,
    tier,
    viewBillingHistoryHandler,
    formatMessage,
  } = props;

  if (!hasPaidTierHistory || tier?.name === TierName.OptedOut) {
    return;
  }

  return {
    name,
    title: billingHistoryDataTitle,
    viewItem: {
      icon: 'IconClock',
      title: formatMessage(
        'account.sweetpass-membership.billing-history.view-item.title',
      ),
      accessibilityLabel: formatMessage(
        'account.sweetpass-membership.billing-history.view-item.accessibility-label',
      ),
      accessibilityHint: formatMessage(
        'account.sweetpass-membership.billing-history.view-item.accessibility-hint',
      ),
      handler: viewBillingHistoryHandler,
    },
  };
};

type GetBillingHistorySectionProps = {
  readonly viewBillingHistoryHandler: () => void;
} & AccountSweetpassBillingHistorySection &
  GetSectionProps;

type SweetpassBillingHistoryViewItem = {
  readonly icon: IconName;
  readonly title: string;
  readonly accessibilityLabel: string;
  readonly accessibilityHint: string;
  readonly handler: () => void;
} & ViewProps;

export type SweetpassBillingHistorySectionProps = {
  readonly name: string;
  readonly title: string;
  readonly viewItem: SweetpassBillingHistoryViewItem;
} & SweetpassSectionProps;
